// extracted by mini-css-extract-plugin
module.exports = {"container":"Home_container__2qRPm","content":"Home_content__21vom"};